import axios from 'axios'

// Add a request interceptor
const axiosInstance = axios.create({
  baseURL: baseURL,
  timeout: '20000'
})

export default axiosInstance
